export default function SidePopupSection({ title, children }) {
    return (
        <div className="side-popup__section">
            { title && <p className="side-popup-section__title">{ title }</p> }
            { children }
        </div>
    )
}